import { Progress } from 'flowbite-react';
import React from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { PiBookOpen } from 'react-icons/pi';
import { UIPrepPlan } from 'types';

interface Props {
	prepPlan: UIPrepPlan;
}

const ChallengeDifficulty = ({ prepPlan }: Props) => {
	return (
		<div className="dark:bg-[#1F2A37] bg-[#FFF] p-[20px] rounded-[12px] md:w-[348px] dark:border-none border">
			<div className="mb-[20px] flex justify-between items-center">
				{['questions'].map((item, index) => {
					return (
						<div key={index} className="flex gap-[16px] items-center">
							<div>
								{item === 'questions' ? (
									<PiBookOpen className="text-[#00CFDE] dark:text-[#A9EFF2] h-[32px] w-[32px]" />
								) : (
									<HiOutlineClock className="text-[#00CFDE] dark:text-[#A9EFF2] h-[32px] w-[32px]" />
								)}
							</div>
							<div>
								<h6 className="text-[20px] font-[700] leading-[24px] dark:text-[#CDF] text-[#7777E7] font-inter">
									{item === 'questions' ? prepPlan.totalProblems || 'NA' : prepPlan.totalHours || 'NA'}
								</h6>
								<p className="text-[12px] font-[400] leading-[16px] dark:text-[#8F90A6] text-[#555770] font-inter">
									{item === 'questions' ? 'questions' : 'total hours'}
								</p>
							</div>
						</div>
					);
				})}
			</div>
			<div className="gap-[8px]">
				{[
					{
						type: 'easy',
						text: 'Easy',
						color: '#06C270',
						darkColor: '#57EBA1',
						theme: {
							bar: `space-x-2 rounded-full text-center font-medium leading-none !bg-[#39D98A] dark:bg-[#57EBA1]`,
						},
						count: prepPlan?.questionsBreakup?.easy || 0,
					},
					{
						type: 'medium',
						text: 'Medium',
						color: '#FC0',
						darkColor: '#FCCC75',
						theme: {
							bar: `space-x-2 rounded-full text-center font-medium leading-none !bg-[#FCCC75] dark:bg-[#FCCC75]`,
						},
						count: prepPlan?.questionsBreakup?.medium || 0,
					},
					{
						type: 'hard',
						text: 'Hard',
						color: '#FF3B3B',
						darkColor: '#FF8080',
						theme: {
							bar: `space-x-2 rounded-full text-center font-medium leading-none !bg-[#FF8080] dark:bg-[#FF8080]`,
						},
						count: prepPlan?.questionsBreakup?.hard || 0,
					},
				].map((item, index) => {
					return (
						<div className="mt-[10px]" key={index}>
							<p
								className={`text-[12px] font-[400] leading-[16px] font-inter text-[${item.color}] dark:text-[${item.darkColor}]`}
							>
								{item.text}
							</p>
							<div className=" flex items-center justify-between gap-[12px]">
								<div className="flex-1">
									<Progress
										theme={item.theme}
										progress={prepPlan.totalProblems ? (item.count / prepPlan.totalProblems) * 100 : 0}
										className="prepare-banner-progress-bar rounded-[8px] progress-bar md:mt-2 "
									/>
								</div>
								<p className="text-[14px] font-[500] leading-[20px] font-inter dark:text-[#CDF] text-[#7777E7]">
									{item.count || 0}
									<span className="ml-[8px] text-[12px] font-[400] leading-[16px] font-inter dark:text-[#8F90A6] text-[#555770]">
										questions
									</span>
								</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ChallengeDifficulty;
